"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: login/verification-service.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Flogin%2Fverification-service.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.VerificationServiceClient = exports.validateEmailResponseValidationToJSON = exports.validateEmailResponseValidationFromJSON = exports.SendSponsorVerificationResponse = exports.SendSponsorVerificationRequest = exports.ValidateEmailResponse = exports.ValidateEmailRequest = exports.ReVerifyResponse = exports.ReVerifyRequest = exports.VerifyResponse = exports.VerifyRequest = exports.ValidateEmailResponseValidation = void 0;
/* eslint-disable */
const rpc_1 = require("@getstep/proto-lib/rpc");
const alias_1 = require("../common/alias");
const masked_alias_1 = require("../common/masked-alias");
const otp_delivery_method_1 = require("./otp-delivery-method");
const protobufPackage = 'com.step.login.proto';
var ValidateEmailResponseValidation;
(function (ValidateEmailResponseValidation) {
    ValidateEmailResponseValidation["UNKNOWN"] = "UNKNOWN";
    /**
     * INVALID - Email is invalid.
     */
    ValidateEmailResponseValidation["INVALID"] = "INVALID";
    /**
     * RISKY - Email has a chance of being invalid, according to sendgrid.
     */
    ValidateEmailResponseValidation["RISKY"] = "RISKY";
    /**
     * VALID - Email is most likely valid.
     */
    ValidateEmailResponseValidation["VALID"] = "VALID";
    ValidateEmailResponseValidation["UNRECOGNIZED"] = "UNRECOGNIZED";
})(ValidateEmailResponseValidation || (exports.ValidateEmailResponseValidation = ValidateEmailResponseValidation = {}));
function createBaseVerifyRequest() {
    return { alias: alias_1.Alias.fromPartial({}), otpDeliveryMethod: undefined };
}
exports.VerifyRequest = {
    fromJSON(object) {
        const message = {
            alias: isSet(object.alias) ? alias_1.Alias.fromJSON(object.alias) : alias_1.Alias.fromPartial({}),
        };
        if (isSet(object.otpDeliveryMethod)) {
            message.otpDeliveryMethod = otp_delivery_method_1.OtpDeliveryMethod.fromJSON(object.otpDeliveryMethod);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.alias !== undefined) {
            obj.alias = alias_1.Alias.toJSON(message.alias);
        }
        if (message.otpDeliveryMethod !== undefined) {
            obj.otpDeliveryMethod = otp_delivery_method_1.OtpDeliveryMethod.toJSON(message.otpDeliveryMethod);
        }
        return obj;
    },
    create(base) {
        return exports.VerifyRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseVerifyRequest();
        message.alias = (object.alias !== undefined && object.alias !== null)
            ? alias_1.Alias.fromPartial(object.alias)
            : alias_1.Alias.fromPartial({});
        message.otpDeliveryMethod =
            (object.otpDeliveryMethod !== undefined && object.otpDeliveryMethod !== null)
                ? otp_delivery_method_1.OtpDeliveryMethod.fromPartial(object.otpDeliveryMethod)
                : undefined;
        return message;
    },
};
function createBaseVerifyResponse() {
    return { otpTtlMs: '0' };
}
exports.VerifyResponse = {
    fromJSON(object) {
        const message = {
            otpTtlMs: isSet(object.otpTtlMs) ? globalThis.String(object.otpTtlMs) : '0',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.otpTtlMs !== '0') {
            obj.otpTtlMs = message.otpTtlMs;
        }
        return obj;
    },
    create(base) {
        return exports.VerifyResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseVerifyResponse();
        message.otpTtlMs = object.otpTtlMs ?? '0';
        return message;
    },
};
function createBaseReVerifyRequest() {
    return { alias: undefined, otpDeliveryMethod: undefined };
}
exports.ReVerifyRequest = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.alias)) {
            message.alias = masked_alias_1.MaskedAlias.fromJSON(object.alias);
        }
        if (isSet(object.otpDeliveryMethod)) {
            message.otpDeliveryMethod = otp_delivery_method_1.OtpDeliveryMethod.fromJSON(object.otpDeliveryMethod);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.alias !== undefined) {
            obj.alias = masked_alias_1.MaskedAlias.toJSON(message.alias);
        }
        if (message.otpDeliveryMethod !== undefined) {
            obj.otpDeliveryMethod = otp_delivery_method_1.OtpDeliveryMethod.toJSON(message.otpDeliveryMethod);
        }
        return obj;
    },
    create(base) {
        return exports.ReVerifyRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseReVerifyRequest();
        message.alias = (object.alias !== undefined && object.alias !== null)
            ? masked_alias_1.MaskedAlias.fromPartial(object.alias)
            : undefined;
        message.otpDeliveryMethod =
            (object.otpDeliveryMethod !== undefined && object.otpDeliveryMethod !== null)
                ? otp_delivery_method_1.OtpDeliveryMethod.fromPartial(object.otpDeliveryMethod)
                : undefined;
        return message;
    },
};
function createBaseReVerifyResponse() {
    return {};
}
exports.ReVerifyResponse = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.ReVerifyResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseReVerifyResponse();
        return message;
    },
};
function createBaseValidateEmailRequest() {
    return { email: '' };
}
exports.ValidateEmailRequest = {
    fromJSON(object) {
        const message = {
            email: isSet(object.email) ? globalThis.String(object.email) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.email !== '') {
            obj.email = message.email;
        }
        return obj;
    },
    create(base) {
        return exports.ValidateEmailRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseValidateEmailRequest();
        message.email = object.email ?? '';
        return message;
    },
};
function createBaseValidateEmailResponse() {
    return {
        suggestion: undefined,
        validity: ValidateEmailResponseValidation.UNKNOWN,
        hasKnownBounces: false,
        hasSuspectedBounces: false,
    };
}
exports.ValidateEmailResponse = {
    fromJSON(object) {
        const message = {
            validity: isSet(object.validity)
                ? validateEmailResponseValidationFromJSON(object.validity)
                : ValidateEmailResponseValidation.UNKNOWN,
        };
        if (isSet(object.suggestion)) {
            message.suggestion = globalThis.String(object.suggestion);
        }
        if (isSet(object.hasKnownBounces)) {
            message.hasKnownBounces = globalThis.Boolean(object.hasKnownBounces);
        }
        if (isSet(object.hasSuspectedBounces)) {
            message.hasSuspectedBounces = globalThis.Boolean(object.hasSuspectedBounces);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.suggestion !== undefined) {
            obj.suggestion = message.suggestion;
        }
        if (message.validity !== ValidateEmailResponseValidation.UNKNOWN) {
            obj.validity = validateEmailResponseValidationToJSON(message.validity);
        }
        if (message.hasKnownBounces !== undefined && message.hasKnownBounces !== false) {
            obj.hasKnownBounces = message.hasKnownBounces;
        }
        if (message.hasSuspectedBounces !== undefined && message.hasSuspectedBounces !== false) {
            obj.hasSuspectedBounces = message.hasSuspectedBounces;
        }
        return obj;
    },
    create(base) {
        return exports.ValidateEmailResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseValidateEmailResponse();
        message.suggestion = object.suggestion ?? undefined;
        message.validity = object.validity ?? ValidateEmailResponseValidation.UNKNOWN;
        message.hasKnownBounces = object.hasKnownBounces ?? false;
        message.hasSuspectedBounces = object.hasSuspectedBounces ?? false;
        return message;
    },
};
function createBaseSendSponsorVerificationRequest() {
    return {};
}
exports.SendSponsorVerificationRequest = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.SendSponsorVerificationRequest.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseSendSponsorVerificationRequest();
        return message;
    },
};
function createBaseSendSponsorVerificationResponse() {
    return { otpTtlMs: '0' };
}
exports.SendSponsorVerificationResponse = {
    fromJSON(object) {
        const message = {
            otpTtlMs: isSet(object.otpTtlMs) ? globalThis.String(object.otpTtlMs) : '0',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.otpTtlMs !== '0') {
            obj.otpTtlMs = message.otpTtlMs;
        }
        return obj;
    },
    create(base) {
        return exports.SendSponsorVerificationResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSendSponsorVerificationResponse();
        message.otpTtlMs = object.otpTtlMs ?? '0';
        return message;
    },
};
function validateEmailResponseValidationFromJSON(object) {
    switch (object) {
        case 0:
        case 'UNKNOWN':
            return ValidateEmailResponseValidation.UNKNOWN;
        case 1:
        case 'INVALID':
            return ValidateEmailResponseValidation.INVALID;
        case 2:
        case 'RISKY':
            return ValidateEmailResponseValidation.RISKY;
        case 3:
        case 'VALID':
            return ValidateEmailResponseValidation.VALID;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return ValidateEmailResponseValidation.UNRECOGNIZED;
    }
}
exports.validateEmailResponseValidationFromJSON = validateEmailResponseValidationFromJSON;
function validateEmailResponseValidationToJSON(object) {
    switch (object) {
        case ValidateEmailResponseValidation.UNKNOWN:
            return 'UNKNOWN';
        case ValidateEmailResponseValidation.INVALID:
            return 'INVALID';
        case ValidateEmailResponseValidation.RISKY:
            return 'RISKY';
        case ValidateEmailResponseValidation.VALID:
            return 'VALID';
        case ValidateEmailResponseValidation.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.validateEmailResponseValidationToJSON = validateEmailResponseValidationToJSON;
/**
 * Verification Service API.
 *
 * Allows caller to start sign-up or recovery process by verifying a phone
 * number.
 */
class VerificationServiceClient {
    rpc;
    name = 'com.step.login.proto.VerificationService';
    type = rpc_1.ServiceType.PUBLIC;
    path = '/login';
    methods = [{
            name: 'Verify',
            requestType: exports.VerifyRequest,
            responseType: exports.VerifyResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
            adminTokenType: undefined,
        }, {
            name: 'ReVerify',
            requestType: exports.ReVerifyRequest,
            responseType: exports.ReVerifyResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.RESTRICTED },
            adminTokenType: undefined,
        }, {
            name: 'ValidateEmail',
            requestType: exports.ValidateEmailRequest,
            responseType: exports.ValidateEmailResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
            adminTokenType: undefined,
        }, {
            name: 'SendSponsorVerification',
            requestType: exports.SendSponsorVerificationRequest,
            responseType: exports.SendSponsorVerificationResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.RESTRICTED },
            adminTokenType: undefined,
        }];
    constructor(rpc) {
        this.rpc = rpc;
    }
    /**
     * Verifies an alias by generating OTP credentials and sending notification
     * to the specified alias to verify it.
     */
    verify(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[0],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Re-verifies an alias during a recovery session by generating OTP
     * credentials and sending notification to the specified alias to verify it.
     */
    reVerify(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[1],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Validates an email address. Returns whether the email is valid as well as
     * a spelling suggestion if there is one.
     */
    validateEmail(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[2],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Sends an OTP to the user's sponsor which can be used as a recovery login
     * factor.
     */
    sendSponsorVerification(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[3],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
}
exports.VerificationServiceClient = VerificationServiceClient;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=verification-service.js.map